export default "__VITE_PUBLIC_ASSET__d4efe12e__"